import React, { Component } from "react";
import FadeIn from "react-fade-in";

import ActionPlanDisplayCloture from "../general/ActionPlanDisplayCloture";
import EvolutionDisplayCloture from "./EvolutionDisplayCloture";
import SignaturesDisplayCloture from "../general/SignaturesDisplayCloture";
import CardFiles from "../general/CardFiles";

export class SimCloturees extends Component {
  constructor(props) {
    super(props);
    this.refsEvolution = Array(props.evolutions.length).fill(React.createRef());
    this.refsOther = [
      React.createRef(),
      React.createRef(),
    ];
  }

  render() {
    return (
      <>
        {this.props.evolutions &&
          this.props.evolutions.map((evol, idx) => (
            <div ref={this.refsEvolution[idx]} key={idx}>
              <EvolutionDisplayCloture
                evolutionData={evol}
                evolutionType={idx}
              />
            </div>
          ))}
        <FadeIn>
          {this.props.actionPlan ? (
            <div ref={this.refsOther[0]}>
              <ActionPlanDisplayCloture actionData={this.props.actionPlan} />
            </div>
          ) : null}
          <CardFiles id={this.props.id} disableEdition={true} />
          {this.props.signatures ? (
            <div ref={this.refsOther[1]}>
              <SignaturesDisplayCloture signatureData={this.props.signatures} />
            </div>
          ) : null}
        </FadeIn>
      </>
    );
  }
}

export default SimCloturees;
